import { render, staticRenderFns } from "./UserDisplayName.vue?vue&type=template&id=7fc2483c&"
import script from "./UserDisplayName.vue?vue&type=script&lang=ts&"
export * from "./UserDisplayName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports